import horarioBonito from "./horarioBonito";

/*
	«Horario — Periodo» (Actualizaciones v2, 2026-10-29): el nombre de un horario solo («Sábados 12:00 pm – 3:30 pm»)
	no dice si es el de agosto o el de octubre. Donde salga un horario se escribe con su periodo. El módulo no hace falta.
*/

/** "Sábados 12:00 pm – 3:30 pm" (el nombre guardado viene en 24 horas y en singular). */
export const horarioLeido = (nombre: string | null | undefined): string => horarioBonito(nombre, { plural: true, separador: " " });

/** "Sábados 12:00 pm – 3:30 pm — Octubre 2026"; sin periodo, solo el horario; sin nombre, "". */
export const etiquetaHorario = (nombre: string | null | undefined, periodo?: string | null): string => {
	const h = horarioLeido(nombre);
	const p = (periodo || "").trim();
	if (!h) { return p; }
	return p ? `${h} — ${p}` : h;
};

/** Un horario ya leído (fila del Buscador de Horarios) con su periodo: "Sábados 12:00 pm - 3:30 pm — Octubre 2026". */
export const conPeriodo = (horario: string | null | undefined, periodo?: string | null): string => {
	const h = (horario || "").trim(); const p = (periodo || "").trim();
	return h && p ? `${h} — ${p}` : h || p;
};

/** Lo mismo desde un objeto con name / periodName (las filas del servidor). */
export const etiquetaDe = (s: { name?: string | null; periodName?: string | null } | null | undefined): string =>
	s ? etiquetaHorario(s.name, s.periodName) : "";

export default etiquetaHorario;
